import { Window } from "@progress/kendo-react-dialogs";
import { EventForm } from "./EventForm";

function EventAdd(props) {
  return (
    <Window
      title={props.title}
      onClose={props.toggleDialog}
      stage={window.innerWidth < 1000 ? "FULLSCREEN" : "DEFAULT"}
      initialHeight={"90vh"}
      initialWidth={"40%"}
      style={{
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        position: "fixed",
        zIndex: 10000,
      }}
    >
      <EventForm
        toggleDialog={props.toggleDialog}
        isAdded={props.isAdded}
        setIsAdded={props.setIsAdded}
      ></EventForm>
    </Window>
  );
}

export { EventAdd };
